import { render, staticRenderFns } from "./MonitoringCard.vue?vue&type=template&id=248b1778&scoped=true&"
import script from "./MonitoringCard.vue?vue&type=script&lang=ts&"
export * from "./MonitoringCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248b1778",
  null
  
)

export default component.exports